module.exports = __webpack_public_path__ + "img/download-play-store.426276aa.png";